export default [
  {
    component: 'CNavItem',
    name: 'Homepage',
    to: '/homepage',
    icon: 'fa-solid fa-home',
  },
  {
    component: 'CNavItem',
    name: 'Schedule',
    to: '/schedule',
    icon: 'fa-solid fa-file-lines',
  },
  {
    component: 'CNavItem',
    name: 'Account',
    to: '/account',
    icon: 'fa-solid fa-user',
  },
  {
    component: 'CNavItem',
    name: 'Share with me',
    to: '/share',
    icon: 'fa-solid fa-people-group',
  },
]
